// Otto Repricer Service API calls
import axios from "axios";

const PLENTY_API_URL = import.meta.env.VITE_PLENTY_API_URL || "/api/v1/plenty";

// Create axios instance for Otto service
const PlentyApiClient = axios.create({
  baseURL: PLENTY_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
PlentyApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Health check
export const plentyHealthApi = {
  healthCheck: () => PlentyApiClient.get("/health"),
};

export default PlentyApiClient;
